import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "/#history", label: "History", num: "01" },
  { href: "/story", label: "Story", num: "02" },
  { href: "/#flavours", label: "Flavours", num: "03" },
  { href: "/#desserts", label: "Desserts", num: "04" },
  { href: "/#menu", label: "Menu", num: "05" },
  { href: "/#experience", label: "Experience", num: "06" },
  { href: "/#visit", label: "Visit Us", num: "07" },
  { href: "/shop", label: "Shop", num: "08" },
  { href: "/cart-hire", label: "Cart Hire", num: "09" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.4, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50"
    >
      <nav className="mx-4 md:mx-8 mt-4 rounded-full bg-cream/80 backdrop-blur-xl border border-gold/30 shadow-lg shadow-teal/5 px-5 md:px-8 py-3 flex items-center justify-between">
        <a href="/" data-testid="nav-logo" className="flex items-center">
          <img src="/morellis-logo-purple.png" alt="Morelli's Broadstairs — dal 1907" className="h-10 md:h-12 w-auto" />
        </a>
        <div className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-xs uppercase tracking-[0.2em] font-medium text-teal/80 hover:text-gold transition-colors duration-300">
              <span className="font-display italic text-gold mr-1">{l.num}</span>{l.label}
            </a>
          ))}
          <a href="/#visit" data-testid="nav-cta"
            className="rounded-full bg-teal text-cream text-xs uppercase tracking-[0.2em] px-5 py-2.5 hover:bg-gold transition-colors duration-300 active:scale-95">
            Plan a Visit
          </a>
        </div>
        <button data-testid="nav-menu-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu"
          className="lg:hidden w-10 h-10 grid place-items-center rounded-full border border-teal/20">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>
      {open && (
        <motion.div initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }}
          className="lg:hidden mx-4 mt-2 rounded-3xl bg-cream border border-gold/30 shadow-xl p-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-display text-2xl text-teal flex items-baseline gap-3">
              <span className="text-sm italic text-gold">{l.num}</span>{l.label}
            </a>
          ))}
        </motion.div>
      )}
    </motion.header>
  );
};

export default Navbar;
